module.exports = __webpack_public_path__ + "static/img/20.0a8d965.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/20.jpg
// module id = Nm1V
// module chunks = 1